import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from "../baseComponent.js";
import InternalEvent from "../../core/constants/internalEvent.js";
import DashboardService from "../../core/services/dashboardService.js";
import DataService from "../../core/services/data-service/data-service";
import WidgetService from "../../core/services/widgetService.js";
import DashboardBody from "./dashboardBody.jsx";
import DashboardBodyMobile from "./dashboardBodyMobile.jsx";
import DashboardTabs from "./tab/dashboardTabs.jsx";
import EarthQuakeGlobe from "./globe/earthquakes/globe-widget.jsx";
import CrudeOilGlobe from "./globe/crude-oil/crudeOilGlobe.jsx";
import DottedMap from "./dotted-map-widget/dotted-map.jsx";
import AutoHedgeRealtime from "./auto-hedging-widget/autoHedgeRealtime.jsx";
import AutoHedge from "./auto-hedging-widget/autoHedge.jsx";
import WidgetList from "./widget-list/widgetList.jsx";
import SideNav from "../common/sidenav/sidenav.jsx";
import WidgetType from "../../core/constants/widgetType.js";
import {AddControlWidget} from "./control-widget/add-control-widget.jsx";
import {AddSelectionControl} from "./control-widget/selection-contorl/addSelectionControl.jsx";
import {AddDatasetControlWidget} from "./control-widget/add-dataset-control.jsx";
import DashboardConfiguration from "./dashboardConfig.jsx";
import DataStore from "../../core/stores/dataStore";
import styles from "./styles.scss";

import "!style!css!../../vendors/gridster/gridster.css";
import {Share} from "./share/share.jsx";
import TemplateParser from "../../core/utils/templateParser";
import {variableTypes} from "../../components/dashboard/control-widget/selection-contorl/constants";
import {Link} from "react-router";


export default class Dashboard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      dashboards: [],
      activeDashboard: undefined,
      editInputControlWidget: null,
      editSelectionControlWidget: null,
      editDatasetControlWidget: null,
      loaded: false
    };
  }

  componentDidMount() {
    this.resolveDependencies()
      .then(() => {
        this.initDashboards();
        this.subscribe(InternalEvent.Dashboard.EDIT_CONTROL_WIDGET, this.editControlWidget);
      });

    this.subscribe(InternalEvent.App.COLOR_CHANGED, colors => {
      this.refs.dashboardContainer.style.background = colors.background;
    });
  }

  componentWillUnmount() {
    DataStore.emptyAllEvents();
    DataService.flushServerSideFunctionCache();
    this.unsubscribeAll();
    this.publish(InternalEvent.App.DASHBOARD_UNMOUNTED);
    ReactDOM.unmountComponentAtNode(this.refs.dashboardBodyContainer);
  }

  resolveDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../vendors/jsep/jsep.js');
          require('../../vendors/gridster/gridster-0.5.6.js');
          require("../../vendors/jquery-mousewheel/jquery.mousewheel.js");
          resolve();
        });
      }

      catch (err) {
        reject(err);
      }
    });
  }

  initDashboards() {
    DashboardService.getAllDashboards()
      .then((dashboards) => {
        if (dashboards.length === 0) {
          throw new Error(`Cannot initialize dashboard. Not found dashboards`);
        }
        else {
          let activatedDashboard = this.findActivatedDashboard(dashboards);
          this.setState({
            dashboards: dashboards,
            activeDashboard: activatedDashboard
          });
          this.renderDashboard(activatedDashboard);
        }
      });
  }

  handleShowTab() {
    DashboardService.getAllDashboards(true)
      .then((dashboards) => {
        if (dashboards.length === 0) {
          throw new Error(`Cannot initialize dashboard. Not found dashboards`);
        }
        else {
          let activatedDashboard = this.findActivatedDashboard(dashboards);
          this.setState({
            dashboards: dashboards,
            activeDashboard: activatedDashboard
          });
        }
      });
  }

  handleDashboardUpdate() {
    DashboardService.getAllDashboards()
      .then((dashboards) => {
        this.setState({
          dashboards: dashboards
        });
      });
  }

  renderDashboard(activatedDashboard) {
    if (activatedDashboard !== null) {
      localStorage.setItem("lastOpenedDashboard", activatedDashboard.persistenceId);
      if (activatedDashboard.originalDashboard) {
        DashboardService.checkSharedDashboardForUpdate(activatedDashboard)
          .then(() => {
            this._renderDashboard(activatedDashboard);
          })
      } else {
        this._renderDashboard(activatedDashboard);
      }
    } else {
      throw new Error(`Activated dashboard not found.`);
    }
  }

  _renderDashboard(activatedDashboard) {
    DashboardService.findDashboardStateByDashboardId(activatedDashboard.persistenceId)
      .then(state => {
        this.setState({
          loaded: true
        });
        let dashboardComponent = this.createDashboardComponent(activatedDashboard, state);
        ReactDOM.unmountComponentAtNode(this.refs.dashboardBodyContainer);
        ReactDOM.render(dashboardComponent, this.refs.dashboardBodyContainer);
      });
  }

  showSideNav() {
    this.refs.sideNav.showSideNav();
  }

  hideSideNav() {
    this.refs.sideNav.hideSideNav();
  }

  findActivatedDashboard(dashboards) {
    let activatedDashboard = null;
    for (let i = 0; i < dashboards.length; i++) {
      if (dashboards[i].activated) {
        activatedDashboard = dashboards[i];
        break;
      }
    }
    return activatedDashboard;
  }

  /***
   * Update variables in the dashboard
   * @param variables [{id, value}, {id, value}...]
   */
  handleDashboardVariableUpdate(variables) {
    const variablesCopy = JSON.parse(JSON.stringify(DashboardService.getCurrentDashboardVariables()));
    variables.forEach(v => {
      variablesCopy[v.id] = v;
    });
    // console.log(variablesCopy);
    return this.updateActiveDashboard(variablesCopy);
  }

  updateActiveDashboard(dashboardVariable) {
    const copy = JSON.parse(JSON.stringify(this.state.activeDashboard));
    copy.variables = dashboardVariable;

    // for (let prop in copy.variables) {
    //   if (copy.variables[prop].type === variableTypes.EXPRESSION) {
    //     const parsed = TemplateParser.parseTemplate(copy.variables[prop].value, true);
    //     try {
    //       const evaluated = eval(parsed);
    //       copy.variables[prop].value = evaluated;
    //     } catch (e) {
    //     }
    //   }
    // }

    DashboardService.evaluateDashboardVariables(copy.variables);

    this.dashboardVariables = copy.variables;
    return DashboardService.updateDashboard(copy, copy)
      .then(() => {
        return this.handleDashboardUpdate();
      });
  }

  toggleLockDashboard(value) {
    this.handleDashboardVariableUpdate([{
      id: "lockDashboard",
      value: value
    }]).then(() => {
      this.publish(InternalEvent.Dashboard.DASHBOARD_LOCK_TOGGLED);
    });
  }

  createDashboardComponent(dashboard, state) {
    let dashboardComponent = null;
    dashboard.state = state;
    switch (dashboard.title) {
      case "OIL globe":
        dashboardComponent = React.createElement(CrudeOilGlobe);
        break;
      case "AUTO HEDGING":
        dashboardComponent = React.createElement(AutoHedgeRealtime, {onOrderClick: this.onOrderClick});
        break;
      case "OIL PRODUCTION":
        dashboardComponent = React.createElement(DottedMap);
        break;
      case "EARTHQUAKES":
        dashboardComponent = React.createElement(EarthQuakeGlobe);
        break;
      default:
        dashboardComponent = isMobile() ?
          React.createElement(DashboardBodyMobile, {dashboard: dashboard}) :
          React.createElement(DashboardBody, {
            updateDashboardVariable: this.handleDashboardVariableUpdate,
            dashboard: dashboard,
            onVariableUpdated: this.handleDashboardVariableUpdate,
            reloadDashboard: this.reloadDashboard,
            router: this.context.router
          });
    }
    return dashboardComponent;
  }

  handleTabChange(dashboardId) {
    this.showPreloader();
    DataService.flushServerSideFunctionCache();
    DashboardService.changeActiveDashboard(dashboardId);
    this.findActiveDashboardAndRender(true);
  }

  reloadDashboard() {
    this.showPreloader();
    DataService.flushServerSideFunctionCache();
    this.findActiveDashboardAndRender(true);
  }

  deleteDashboard(dashboardId) {
    DashboardService.deleteDashboard(dashboardId)
      .then(() => this.findActiveDashboardAndRender());
  }

  handleSharedDashboardDeleted() {
    this.findActiveDashboardAndRender();
  }

  findActiveDashboardAndRender(forceRender = false) {
    DashboardService.getAllDashboards()
      .then(dashboards => {
        const activeDashboard = dashboards.find(d => d.activated);
        if (this.state.activeDashboard.persistenceId !== activeDashboard.persistenceId || forceRender) {
          this.renderDashboard(activeDashboard);
        } else {
          this.hidePreloader();
        }
        this.setState({
          dashboards,
          activeDashboard: activeDashboard,
          editInputControlWidget: null,
          editSelectionControlWidget: null,
          editDatasetControlWidget: null
        });
      });
  }

  handleWidgetOptionClick(widgetType, widgetSubType) {
    this.hideSideNav();
    switch (widgetType) {
      case WidgetType.CONTROL_WIDGET: {
        this.showControlWidget(widgetSubType);
        break;
      }
      case WidgetType.SEPARATOR_VERTICAL: {
        this.publish(InternalEvent.Dashboard.ADD_VERTICAL_SEPARATOR_WIDGET);
        break;
      }
      default: {
        WidgetService.setAddWidgetType(widgetType);
        setTimeout(() => {
          this.context.router.push("/addWidget");
        }, 500);
      }
    }
  }

  onOrderClick(volume) {
    ReactDOM.unmountComponentAtNode(this.refs.dashboardBodyContainer);
    ReactDOM.render(React.createElement(AutoHedge, {volume: volume}), this.refs.dashboardBodyContainer);
  }

  showSettingDialog() {
    this.refs.settings.show();
    // this.refs.addInputControlWidget.show();
  }

  editControlWidget(widget) {
    this.showControlWidget(widget.metaData.type, widget);
  }

  showControlWidget(type, widget) {
    const state = {};
    let ref;
    switch (type) {
      case "input":
        ref = "addInputControlWidget";
        state.editInputControlWidget = widget;
        break;
      case "selection":
        ref = "addSelectionControlWidget";
        state.editSelectionControlWidget = widget;
        break;
      case "dataset":
        ref = "addDatasetControlWidget";
        state.editDatasetControlWidget = widget;
        break;
    }
    this.setState(state);
    this.refs[ref].show();
  }

  getDefaultDashboardColors() {
    return {
      background: "white"
    }
  }

  switchToDesktopMode() {
    window.forceDesktopMode = true;
    this.publish(InternalEvent.App.SHOW_NAVBAR);
  }

  render() {
    const dashboardColors = DashboardService.getCurrentDashboardVariableById("colors") || this.getDefaultDashboardColors();
    const isDashboardLocked = DashboardService.getActiveDashboardLockState();
    const lockButton = isDashboardLocked ?
      <i className={["icon-lock", styles.unLockBtn].join(" ")} onClick={() => this.toggleLockDashboard(false)}/> :
      <i className={["icon-lock-open", styles.lockBtn].join(" ")} onClick={() => this.toggleLockDashboard(true)}/>;

    return (
      <div className={styles.dashboardContainer} ref="dashboardContainer"
           style={{background: dashboardColors.background}}>
        {this.state.loaded ? <DashboardTabs tabs={this.state.dashboards}
                                            onShare={() => this.refs.share.show()}
                                            onTabChange={(id) => this.handleTabChange(id)}
                                            onDashboardDelete={this.deleteDashboard}
                                            onDashboardUpdate={this.handleDashboardUpdate}
                                            onSharedDashboardDeleted={this.handleSharedDashboardDeleted}
                                            onShowTab={this.handleShowTab}/> : null}
        <div className={styles.dashboardBodyContainerWrapper}>
          <div ref="dashboardBodyContainer" style={{width: '100%'}}/>
        </div>
        {
          isMobile() ? null : lockButton
        }
        {
          isMobile() ? null : <i className={["icon-plus", styles.addWidgetBtn].join(" ")} onClick={this.showSideNav}/>
        }
        <SideNav ref="sideNav" width="670">
          <WidgetList onClick={this.handleWidgetOptionClick}/>
        </SideNav>

        <AddSelectionControl editControlWidget={this.state.editSelectionControlWidget}
                             onUpdated={this.updateActiveDashboard} ref="addSelectionControlWidget"/>

        <AddControlWidget editControlWidget={this.state.editInputControlWidget}
                          onUpdated={this.updateActiveDashboard} ref="addInputControlWidget"/>

        <AddDatasetControlWidget editControlWidget={this.state.editDatasetControlWidget}
                                 onUpdated={this.updateActiveDashboard} ref="addDatasetControlWidget"/>

        {
          this.state.activeDashboard ?
            <DashboardConfiguration ref="configuration" activeDashboard={this.state.activeDashboard}
                                    getDefaultDashboardColors={this.getDefaultDashboardColors}/> : null
        }
        <Share ref="share"/>
        {
          isMobile() ? null : lockButton
        }
        {
          isMobile() ? <Link to={"/"} className={styles.toDesktopMode} onClick={this.switchToDesktopMode}>Switch to
            Desktop Mode</Link> : null

        }
      </div>
    )
  }
}

Dashboard.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.jsx